class FileService {
  async upload(file: File, folder?: string) {
    const body = new FormData();
    body.append('file', file);

    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/upload/files${folder ? `?folder=${folder}` : ''}`, {
      method: 'POST',
      credentials: 'include',
      body,
    });

    const json = await res.json();

    const path = json.data[0];
    return path.compressedUrl || path.originalUrl;
  }

  async uploadFile(file: File, folder?: string, returnOriginal: boolean = false, type?: 'cover'): Promise<string> {
    const body = new FormData();
    body.append('file', file);

    const params = new URLSearchParams();
    if (folder) params.set('folder', folder);
    if (type) params.set('type', type);
    const queryString = params.toString();

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/upload/files${queryString ? `?${queryString}` : ''}`,
      {
        method: 'POST',
        credentials: 'include',
        body,
      },
    );

    const json = await res.json();

    if (!res.ok) {
      const message = (json as { message?: string }).message ?? 'Ошибка при загрузке файла';
      throw new Error(Array.isArray(message) ? message.join('. ') : message);
    }

    const path = json.data[0];
    return !returnOriginal ? path.compressedUrl || path.originalUrl : path.originalUrl;
  }

  async uploadFiles(files: File[]) {
    const body = new FormData();
    files.forEach((file) => {
      body.append('file', file);
    });

    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/upload/files`, {
      method: 'POST',
      credentials: 'include',
      body,
    });

    const paths = (await res.json()).data;

    return paths;
  }
}

const fileService = new FileService();
export default fileService;
